<template>
  <div 
    class="  px-10 mt-12">
    <v-dialog v-model="dialog.pembayaran"
      @keydown.esc="dialog.pembayaran = false"
      :fullscreen="dialog.fullscreen"
      width="700"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
        class="pa-8 pt-6">
        <v-card-title 
          class="d-flex align-center pa-0 pb-4 text-right popup-header fs-20 font-weight-bold">
          <v-icon left color="#1814F3" class="mr-2">mdi-cash</v-icon>
          Pembayaran
          <v-spacer/>
          <v-icon 
            @click="dialog.pembayaran = false; dialog.fullscreen = false; message.status = ''; message.error = ''"
            class="cursor-pointer"
            size="18"
            color="#000000">
            mdi-close
          </v-icon>
        </v-card-title>
        <v-card-subtitle class="px-0 pb-2 grey--text text--darken-1 fs-14">
          Silakan lengkapi detail pembayaran retur berikut.
        </v-card-subtitle>
        <v-divider class="mb-2"/>
        <!-- Info Invoice/Retur -->
        <div class="mb-4 px-0">
          <v-row dense>
            <v-col cols="6" class="py-1">
              <span class="grey--text fs-13">No. Retur:</span>
              <span class="font-weight-bold ml-1">{{ detail.id || '-' }}</span>
            </v-col>
            <v-col cols="6" class="py-1">
              <span class="grey--text fs-13">Tanggal:</span>
              <span class="font-weight-bold ml-1">{{ detail.created_at ? moment(detail.created_at).format('DD MMM YYYY') : '-' }}</span>
            </v-col>
            <v-col cols="6" class="py-1">
              <span class="grey--text fs-13">Judul:</span>
              <span class="font-weight-bold ml-1">{{ detail.title || '-' }}</span>
            </v-col>
            <v-col cols="6" class="py-1">
              <span class="grey--text fs-13">Nominal:</span>
              <span class="font-weight-bold ml-1">{{ (detail.nominal*1) | price || '-' }}</span>
            </v-col>
          </v-row>
        </div>
        <v-divider class="mb-2"/>
        <v-card-text 
          class="body-1 font-weight-light text-first line-text-second my-0 px-0 py-3">
          <ValidationObserver 
            ref="form">
            <v-form>

              <ValidationProvider
                name="Metode Pembayaran" 
                rules="required" 
                v-slot="{ errors }">
                <div 
                  class="fs-15 label-input mb-1">
                  Metode Pembayaran
                </div>

                <v-autocomplete
                  v-on:keydown.enter.prevent="save()"
                              
                  filled
                  rounded
                  dense
                  solo

                  color="#718EBF"
                  placeholder="Pilih Metode Pembayaran"
                  v-model="form.payment_method"
                  :items="['Tunai','Transfer']"
                  
                  outlined
                  class="mt-2"
                  :error-messages="errors"
                  required
                  style="border-radius: 10px;">
                </v-autocomplete>
              </ValidationProvider>

              <!-- <v-autocomplete
                v-model="form.payment_method"
                :items="['Tunai','Transfer']"
                
                label="Pilih Tipe Pembayaran"
                
                dense
                outlined
                hide-details
                style="width: 100%"
                class="mt-4"
                >
              </v-autocomplete> -->

              <div v-if="form.payment_method === 'Transfer'">
                <ValidationProvider
                  name="Pilih Bank" 
                  rules="required" 
                  v-slot="{ errors }">
                  <div 
                    class="fs-15 label-input mb-1 mt-4">
                    Pilih Bank
                  </div>

                  <v-autocomplete
                    v-on:keydown.enter.prevent="save()"
                                
                    filled
                    rounded
                    dense
                    solo

                    color="#718EBF"
                    item-text="name"
                    item-value="name"
                    placeholder="Pilih Bank"
                    v-model="form.bank"
                    :items="bank"
                    
                    outlined
                    return-object
                    class="mt-2"
                    :error-messages="errors"
                    required
                    style="border-radius: 10px;">
                    <template v-slot:selection="{ item }">
                      <div
                        v-if="item" style="color: #718EBF">
                        {{ item.name }} ({{ item.rek_number }})
                      </div>
                    </template>
                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <v-list-item-title>{{ item.name }}</v-list-item-title>
                        <v-list-item-subtitle>{{ item.rek_number }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </ValidationProvider>
              </div>
            </v-form>
          </ValidationObserver>
          <v-divider class="my-4"/>
          <v-alert v-if="message.error.length > 0" type="error" dense outlined class="mb-2">
            <v-icon left color="red" size="18">mdi-alert-circle-outline</v-icon>
            {{ message.error }}
          </v-alert>
        </v-card-text>


        <!-- <v-divider 
          class="mt-2"
          style="border-top: 2px dashed #e0e0e0;"/> -->

        <v-card-actions
          class="pa-0 pt-4">
          <v-spacer/>

          <v-btn
            rounded
            @click="save()"
            :loading="process.form"
            :disabled="process.form"
            width="160"
            height="45"
            elevation="0"
            color="#1814F3"
            class="fs-16 white--text text-capitalize border-radius mr-2">
            Ya, {{ message.status || 'Bayar' }}
          </v-btn>

          <!-- <v-btn
            rounded
            width="120"
            @click="dialog.pembayaran = false; dialog.fullscreen = false; selected.status = [];"
            :disabled="process.status"
            outlined
            class="body-2 font-weight-bold text-capitalize red--text">
            Batal
          </v-btn> -->
          <v-btn
            rounded
            width="120"
            @click="dialog.pembayaran = false; dialog.fullscreen = false; message.status = ''; message.error = ''"
            :disabled="process.form"
            outlined
            class="body-2 font-weight-bold text-capitalize red--text">
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout wrap>
      <v-flex>
        <section>
          
          <div class="color-dark-blue fs-22 font-weight-bold mb-6">
            Detail Retur
          </div>

          <v-row
            class="mt-3">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                style="border-radius: 25px; border: 1px solid #E7E7E7;">
                <v-card-text
                  v-if="process.load" 
                  class="pb-0 my-4" style="height: 500px; display: flex; align-items: center; justify-content: center;">
                  <div class="text-center">
                    <div class="mb-2 title">
                      Mohon Tunggu...
                    </div>
                    <v-progress-circular
                      indeterminate
                    ></v-progress-circular>
                  </div>
                </v-card-text>

                <v-card-text v-if="!process.load && Object.keys(detail).length > 0">
                  <v-row>
                    <v-col cols="3">
                      <div>
                        <div class="fs-14" style="margin-bottom: 1px;">
                          Judul
                        </div>
                        <div class="fs-16 label-input font-weight-bold">
                          {{ detail.title }}
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="3">
                      <div>
                        <div class="fs-14" style="margin-bottom: 1px;">
                          Kategori
                        </div>
                        <div class="fs-16 label-input font-weight-bold">
                          {{ detail.category }}
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="3">
                      <div>
                        <div class="fs-14" style="margin-bottom: 1px;">
                          Kuota
                        </div>
                        <div class="fs-16 label-input font-weight-bold">
                          {{ detail.quota === '' ? 'Tidak ada kuota' : detail.quota }}
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="3">
                      <div>
                        <div class="fs-14" style="margin-bottom: 1px;">
                          Kuota Terpakai
                        </div>
                        <div class="fs-16 label-input font-weight-bold">
                          {{ detail.quota_used }}
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="3" v-if="detail.category === 'produk'">
                      <div>
                        <div class="fs-14" style="margin-bottom: 1px;">
                          Persen
                        </div>
                        <div class="fs-16 label-input font-weight-bold">
                          {{ detail.percent === '' ? 'Tidak ada persen' : detail.percent }}
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="3" v-if="detail.category === 'transaksi'">
                      <div>
                        <div class="fs-14" style="margin-bottom: 1px;">
                          Minimal Transaksi
                        </div>
                        <div class="fs-16 label-input font-weight-bold">
                          {{ (detail.minimum_transaksi*1) | price }}
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="12">
                      <div>
                        <div class="fs-14" style="margin-bottom: 1px;">
                          Deskripsi
                        </div>
                        <div class="fs-16 label-input font-weight-bold">
                          {{ detail.desc === '' ? '-' : detail.desc }}
                        </div>
                      </div>
                    </v-col>
                    <!-- <v-col cols="12">
                      <div>
                        <div class="fs-14" style="margin-bottom: 1px;">
                          Catatan
                        </div>
                        <div class="fs-16 label-input font-weight-bold">
                          {{ detail.note === '' ? '-' : detail.note }}
                        </div>
                      </div>
                    </v-col> -->
                  </v-row>
                </v-card-text>
              </v-card>

            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">
              
              <v-btn
                to="/retur"
                color="red"
                elevation="0"
                width="140"
                height="45"
                class="body-2 white--text text-capitalize d-flex align-center ml-4 border-radius"
                style="font-weight: 600;">
              
                  Kembali
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>
  
<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        approved_by: [],
        approved_reason: '',
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu: false,
        modal: false,
        menu2: false,
        
        zoomed: false,
        zoomedTtd: false,
        imageAspectRatio: 1,
        imageAspectRatioTtd: 1,
        lastIndex: 1,

        dialog: {
          status: false,
          pembayaran: false,
        },

        order_list: {},
        status: '',

        detail: {},

        rejected_reason: '',
        bank: [],

        form: {
          id: '',
          bpb_arr: [],
          payment_method: 'Tunai',
          payment_bank_name: '',
          payment_rek_number: '',
        },
        headers_data: [
          {
            text: 'No',
            width: '80',
            value: 'index',
            freeze: true,
            hide: false
          },
          {
            text: 'Nama',
            width: '100%',
            value: 'varian_name',
            freeze: true,
            hide: false
          }
        
        ],
        category: [],
        branch: [],

        mobilephone: {
          name: '',
          id: ''
        },

        upload: {
          ttd: null,
          image_url: null
        },
        total_nominal: 0,

        process: {
          form: false,

          load: false,

          image_url: false
        },
        
        message: {
          success: '',
          error: '',
          status: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
    },
    watch: {
      
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },
      configHeaders () {
        return this.headers_data.filter(header => !header.hide)  
      },
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      async fetchDetail () {
        this.process.load = true
        let params = {
          id: this.$route.params.id
        }

        await get('admin/customer_retur/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.detail = res.results.data
          }
          this.process.load = false
        })
      },
      reset (index) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.rejected_reason = ''

        this.process.form = false

        this.message.error = ''
      },
      onImageLoad(e) {
        const img = e.target
        this.imageAspectRatio = img.naturalWidth / img.naturalHeight
      },
      onImageLoadAkta(e) {
        const img = e.target
        this.imageAspectRatioAkta = img.naturalWidth / img.naturalHeight
      },

      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: #FFFFFF;
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: #FFFFFF;
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },

      async save () {
        this.message.error = ''
        const isValid = true
        if (isValid) {
          

        this.process.form = true
        let form = {
          invoice_id: this.detail.id,
          payment_method: this.form.payment_method,
          payment_bank_name: this.form.payment_method === 'Tunai' ? '' : this.form.bank.name,
          payment_rek_number: this.form.payment_method === 'Tunai' ? '' : this.form.bank.rek_number
        }

        let url = 'admin/customer_invoice/payment'

        await post(url, {
          data: form
        }).then(response => {
          let res = response.data

          this.process.form = false

          if (res.status === 200) {

            this.dialog.pembayaran = false

            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetchDetail()
          } else {
            this.message.error = res.message
          }
        })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }

        
      }
    }
  }
</script>

<style>
  table, th, td {
    /* border: 1px solid #ededed;
    border-collapse: collapse; */
    /* border: thin ridge black; */
    border-spacing: 4px;
    border-collapse: collapse;
    border: 1px solid #ededed;
    padding: 10px;
  }
</style>